export default __webpack_public_path__ + "static/pp-8208ce2fc1e535f8e0b94dab7af48149.jpg";